import moment from 'moment'

export default function anularFel(item,motivoAnulacion) {

    const letranit = item.idestablecimiento.nit.split('K')
    let nit = 0;
    if(letranit.lenght>0){
      nit = parseInt(letranit[0])+'K'
    }else{
     nit = parseInt(item.idestablecimiento.nit);
    }    

    //anularFel(nit,autorizacion,nitcliente,fechaemision,motivoanulacion)
    const anularDTE = `
            <?xml version="1.0" encoding="utf-8"?>

        <dte:GTAnulacionDocumento xmlns:dte="http://www.sat.gob.gt/dte/fel/0.1.0"

            xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" Version="0.1">

            <dte:SAT>

                <dte:AnulacionDTE ID="DatosCertificados">

                    <dte:DatosGenerales ID="DatosAnulacion"

                        NumeroDocumentoAAnular="${item.autorizacion}" NITEmisor="${nit}"

                        IDReceptor="${item.idpersona.nit}" FechaEmisionDocumentoAnular="${moment(item.fecha).format()}"

                        FechaHoraAnulacion="${moment().format()}"

                        MotivoAnulacion="${motivoAnulacion}"/>         

                </dte:AnulacionDTE>

            </dte:SAT>

        </dte:GTAnulacionDocumento>
    `
return anularDTE
}
